import { WHATSAPP_NUMBER } from '../constants/site';

export function buildWhatsAppUrl(message) {
    return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}
